<script setup lang="ts">
import { ref } from 'vue'
import axios from 'axios'
import Desktop from './Desktop.vue'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

const email = ref('')
const loading = ref(false)
const message = ref('')
const error = ref('')

function csrfHeaders() {
  const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
  return {
    'X-CSRF-Token': token,
    Accept: 'application/json',
  }
}

async function submit() {
  loading.value = true
  message.value = ''
  error.value = ''

  try {
    const response = await axios.post('/password_resets.json', { email: email.value }, { headers: csrfHeaders() })
    message.value = response.data?.message || 'Wenn die E-Mail existiert, wurde ein Link zum Setzen des Kennworts versendet.'
  } catch (err: any) {
    error.value = err.response?.data?.error || 'Der Link konnte nicht angefordert werden.'
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <Desktop>
    <div class="w-1/2 flex flex-col justify-top">
      <Card class="w-full max-w-sm hoeppner-bg">
        <CardHeader>
          <CardTitle class="text-center">Kennwort vergessen</CardTitle>
        </CardHeader>
        <CardContent>
          <form class="space-y-4" @submit.prevent="submit">
            <p class="text-sm text-muted-foreground">
              Geben Sie Ihre E-Mail-Adresse ein. Wenn ein aktiver Nutzer existiert, senden wir einen Link zum Setzen des Kennworts.
            </p>

            <div class="space-y-2">
              <Label for="reset_email">E-Mail</Label>
              <Input id="reset_email" v-model="email" type="email" required autocomplete="email" />
            </div>

            <p v-if="message" class="text-sm text-green-700">{{ message }}</p>
            <p v-if="error" class="text-sm text-red-700">{{ error }}</p>

            <Button :disabled="loading" class="w-full greenbutton">
              {{ loading ? 'Senden...' : 'Link anfordern' }}
            </Button>

            <div class="text-center text-sm">
              <a href="/login" class="underline">Zur Anmeldung</a>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  </Desktop>
</template>

<style scoped>
.hoeppner-bg {
  background-color: #F4F3F3 !important;
  border-radius: 0 !important;
}

.greenbutton {
  background-color: #80BA27 !important;
}
</style>
